import { useSafeArea } from "@provider/safe-area/use-safe-area";
import type { SxProp } from "dripsy";
import { View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

export default function SafeHorizontal({
  children,
  sx,
  pointerEvents,
}: {
  children: any;
  sx?: SxProp;
  pointerEvents?: any;
}) {
  const { left, right } = useSafeArea();
  const pointerEventsProps = Platform.OS !== "web" && pointerEvents ? { pointerEvents } : {};

  return (
    <View
      sx={{ marginLeft: left, marginRight: right, ...(Platform.OS === "web" && pointerEvents ? { pointerEvents } : {}), ...sx } as any}
      {...pointerEventsProps}
    >
      {children}
    </View>
  );
}
